module.exports = __webpack_public_path__ + "static/car-dashboard-e94181656e7e70008a3989fb8b346b29.jpg";